import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4" }
const _hoisted_2 = { class: "flex justify-center md:justify-start flex-wrap flex-row md:mr-auto md:ml-0 mx-auto w-full" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "px-5" }
const _hoisted_8 = { class: "py-6" }
const _hoisted_9 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_10 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_11 = { class: "p-1 m-1 text-center" }
const _hoisted_12 = { class: "text-center" }

import { inject, onMounted, ref, watch } from "vue";
import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Navbar from "@/components/tools/Navbar.vue";
import Pagination from "@/components/tools/Pagination.vue";
import CommissionSummaryDialog from "@/components/dialogs/CommissionSummaryDialog.vue";
import { formatNumber, translate } from "@/utils/tools";
import DateSelector from "@/components/tools/DateSelector.vue";
import DropdownComponent from "@/components/tools/DropdownComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CommissionSummaryV2',
  setup(__props) {

dayjs.extend(localizedFormat);

const SearchIcon = require("@heroicons/vue/solid/SearchIcon");

const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const userData: any = ref([]);
const advanceFilterModal = ref<boolean>(false);
const detailDialogModal = ref<boolean>(false);
const showErrorDetail = ref<boolean>(false);
const errorMessage = ref<string>("");
const dateSelectorRef = ref();

const selectedOption = ref({
  label: "Last 30 Days",
  value: dayjs().add(-30, "day").format(),
});
// {
//   label: "Yesterday",
//   value: dayjs().add(-1, "day").format(),
// })

const months: any = ref([]);
const beginningDate = "2022-01-01";
const diff = dayjs().diff(beginningDate, "months");
for (let i = 0; i <= diff; i++) {
  months.value.push({
    label: dayjs(beginningDate).add(i, "month").format("MM/YYYY"),
    value: dayjs(beginningDate).add(i, "month").format(),
  });
}
months.value.push(
  {
    label: "Last 30 Days",
    value: dayjs().add(-30, "day").format(),
  },
  {
    label: "Yesterday",
    value: dayjs().add(-1, "day").format(),
  }
);

const onMonthChange = (data: any) => {
  selectedOption.value = data;
  filterByMonth(data);
};

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.startDate = payload.from
    ? dayjs(payload.from).format("YYYY-MM-DD")
    : dayjs().startOf("month").format("YYYY-MM-DD");
  filterForm.value.endDate = payload.to
    ? dayjs(payload.to).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD");
  isLoaded.value = false;
  pageConfig.value.page = 1;
  fetchPageData();
};

const filterByMonth = (payload: any) => {
  let from: any = dayjs(payload.value).startOf("month").format("YYYY-MM-DD");
  let to: any = dayjs(payload.value).endOf("month").format("YYYY-MM-DD");
  if (payload.label == "Yesterday") {
    from = dayjs(payload.value)
      .add(-1, "day")
      .hour(0)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD");
    to = dayjs(payload.value)
      .hour(23)
      .minute(59)
      .second(59)
      .format("YYYY-MM-DD");
  }
  if (payload.label == "Last 30 Days") {
    (from = dayjs(payload.value)
      .add(-30, "day")
      .hour(0)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD")),
      (to = dayjs(payload.value)
        .hour(23)
        .minute(59)
        .second(59)
        .format("YYYY-MM-DD"));
  }

  // console.log('dateSelectorRef', dateSelectorRef);
  dateSelectorRef.value.state = {
    from: dayjs(from).format("YYYY-MM-DD"),
    to: dayjs(to).format("YYYY-MM-DD"),
  };

  isLoaded.value = false;
  filterForm.value.startDate = from;
  filterForm.value.endDate = to;
  fetchPageData();
};

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  search: "",
  isEmitOnClick: true,
  sort: [["win_loss", "ASC"]],
});
const filterForm = ref({
  moduleCode: undefined,
  roundId: undefined,
  userAlias: undefined,
  userPhone: undefined,
  userId: undefined,
  // startDate: dayjs('2022-01-01').startOf("month").format("YYYY-MM-DD"),
  startDate: dayjs().add(-1, "day").format(),
  endDate: dayjs().format("YYYY-MM-DD"),
  status: undefined,
  // from: null,
  // to: null,
});

const showDetailDialog = async (data: any) => {
  const operator_id = store.state.selectedOperator.operatorId;
  const user_id = data.affiliate.userId;
  userData.value = await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/customers/get_commission`, {
      operator_id,
      user_id,
    })
    .then((res) => {
      detailDialogModal.value = true;
      res.data.userId = user_id;
      return [res.data];
    })
    .catch((err) => {
      detailDialogModal.value = false;
      alert(`${err.response.data.error}:\n${err.response.data.message}`);
    });
};

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Win/Loss") attName = "win_loss";
  if (attName === "Account Name") attName = "accountName";
  if (attName === "Bet") attName = "bet_total";
  if (attName === "Settle") attName = "settle_total";
  if (attName === "Topup") attName = "topup_total";
  if (attName === "Withdraw") attName = "withdraw_total";
  if (attName === "RTB Deposit") attName = "rtb_deposit_total";
  if (attName === "RTB Withdraw") attName = "rtb_withdraw_total";
  sort[0] = [attName, mode === "DESC" ? "ASC" : "DESC"];
  fetchPageData(true);
};

const filterModal = (flag?: number) => {
  if (flag === 1) {
    fetchPageData(true);
  } else {
    fetchPageData(false);
  }
  advanceFilterModal.value = false;
  detailDialogModal.value = false;
};

const search = (e: any) => {
  if (
    e.code == "Enter" || e.code == "NumpadEnter" || e.keyCode == 13 ||
    pageConfig.value.search.length == 10 ||
    pageConfig.value.search.length == 0
  ) {
    fetchPageData(true);
  }
};

const fetchPageData = async (reset = false) => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort } = pageConfig.value;

  if (selectedOption.value.label == "Last 30 Days") {
    dateSelectorRef.value.state = {
      from: dayjs()
        .add(-30, "day")
        .hour(0)
        .minute(0)
        .second(0)
        .format("YYYY-MM-DD"),
      to: dayjs().hour(0).minute(0).second(0).format("YYYY-MM-DD"),
    };
  }

  const { startDate, endDate } = filterForm.value;
  let offset = (page - 1) * rowsPerPage;
  if (reset) {
    offset = 0;
    pageConfig.value.page = 1;
  }

  const payload: any = {
    operator_id: store.state.selectedOperator.operatorId,
    start_date: startDate,
    end_date: endDate,
    sort_by: sort[0],
    limit: rowsPerPage,
    offset: offset,
    search: pageConfig.value.search,
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/cms/summaries/get-list`;
  const data = await axios.post(url, payload).then(({ data }) => data);

  if (!data || data.length == 0) {
    if (pageConfig.value.page == 1) {
      dataRows.value = [];
      isLoaded.value = true;
      return;
    }
    pageConfig.value.page = page - 1;
    return;
  }

  dataRows.value = data;
  if (dataRows.value.length > 0) {
    dataRows.value.map((item: any) => {
      item.accountName = item.affiliate.accountName;
      item.username = item.affiliate.username;
    });
  }

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

const columns = ref([
  {
    label: translate("messages.commissionSummary.accountName"),
    field: "accountName",
    isSorted: true,
    sort: true,
  },
  {
    label: translate("messages.commissionSummary.username"),
    field: "username",
    isSorted: true,
    sort: true,
  },
  {
    label: translate("messages.commissionSummary.winLoss"),
    field: "win_loss",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.win_loss),
    class: (data: any) => {
      if (Number(data.win_loss) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.commissionSummary.bet"),
    field: "bet_total",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.bet_total),
  },
  {
    label: translate("messages.commissionSummary.validBet"),
    field: "total_valid_bet",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => formatNumber(data.total_valid_bet),
    class: (data: any) => {
      return Number(data.total_valid_bet) < 0
        ? "text-red-500"
        : "text-green-500";
    },
  },
  {
    label: translate("messages.commissionSummary.settle"),
    field: "settle_total",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.settle_total),
  },

  {
    label: translate("messages.commissionSummary.topup"),
    field: "topup_total",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.topup_total),
    class: (data: any) => {
      if (Number(data.betAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },

  {
    label: translate("messages.commissionSummary.withdraw"),
    field: "withdraw_total",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.withdraw_total),
    class: (data: any) => {
      if (Number(data.settleAmount) < 0) return "text-red-500";
      return "text-green-500";
    },
  },
  {
    label: translate("messages.commissionSummary.rtbDeposit"),
    field: "rtb_deposit_total",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.rtb_deposit_total),
  },
  {
    label: translate("messages.commissionSummary.rtbWithdraw"),
    field: "rtb_withdraw_total",
    isSorted: true,
    sort: true,
    format: (data: any) => formatNumber(data.rtb_withdraw_total),
  },
  {
    label: translate("messages.commissionSummary.viewDetail"),
    field: "action",
    sort: false,
    isButton: true,
    isRow: true,
    buttonTitle: "View Details",
  },
]);

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.commissionSummary.commissionSummary')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (search($event))),
              maxlength: "10",
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              placeholder: _ctx.$t('messages.commissionSummary.search'),
              type: "search",
              name: "search"
            }, null, 40, _hoisted_6), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(DropdownComponent, {
            modelValue: selectedOption.value,
            options: months.value,
            onOnOptionSelected: onMonthChange
          }, null, 8, ["modelValue", "options"])
        ]),
        _createVNode(DateSelector, {
          class: "px-5",
          onSearch: onSearch,
          ref_key: "dateSelectorRef",
          ref: dateSelectorRef
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            onShowDetailTable: showDetailDialog,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event)),
            onChangePage: _cache[3] || (_cache[3] = () => {})
          }, null, 8, ["config"])
        ])
      ])
    ]),
    _createVNode(CommissionSummaryDialog, {
      show: detailDialogModal.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((detailDialogModal).value = $event)),
      userData: userData.value,
      onSubmit: _cache[5] || (_cache[5] = ($event: any) => (filterModal(0)))
    }, null, 8, ["show", "userData"]),
    _createVNode(DialogComponent, { isOpen: showErrorDetail.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, _toDisplayString(errorMessage.value), 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "bg-red-500 rounded p-2 text-white",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (showErrorDetail.value = false))
          }, _toDisplayString(_ctx.$t("messages.commissionSummary.close")), 1)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}
}

})